import * as React from 'react';
import Api from '../services/Api';

export interface ISecurityTrimmerProps {
    role: string;
    children: string | React.JSX.Element | React.JSX.Element[];
}

export interface ISecurityTrimmerState {
    hasAccess: boolean;
}

export default class SecurityTrimmer extends React.Component<ISecurityTrimmerProps, ISecurityTrimmerState> {
    public constructor(props: ISecurityTrimmerProps) {
        super(props);

        this.state = {
            hasAccess: false
        }
    }

    componentDidMount(): void {
        this.checUserRole();
    }

    public render(): React.ReactElement<{}> {
        const { hasAccess } = this.state;

        return (
            <React.Fragment>
                {
                    hasAccess && (
                        this.props.children
                    )
                }
            </React.Fragment>
        )
    }

    private async checUserRole() {
        console.log(this.props.role);
        const [inRole] = await Promise.all([
            Api.get(`/api/Users/inrole/${this.props.role}`)
        ]);

        const hasAccess = await inRole.json();

        this.setState({ hasAccess: hasAccess });
    }
}